export const gr = {
  translation: {
    Login: "Είσοδος",
    "Create Account": "Δημιουργία Λογαριασμού",
    Email: "Email",
    "Your email": "Το email σου",
    Password: "Κωδικός",
    "Your password": "Ο κωδικός σου",
    "Forgot your password?": "Ξέχασες τον κωδικό σου?",
    "By continuing, you agree with the Privacy Policy and the Terms of Use. The site uses cookies as explained in the Privacy Policy.":
      "Συνεχίζοντας, συμφωνείτε με την Πολιτική Απορρήτου και τους Όρους Χρήσης. Ο ιστότοπος χρησιμοποιεί cookies όπως εξηγείται στην Πολιτική Απορρήτου.",
    Back: "Πίσω",
    CreateAccountHeaderLabel: "{value}",
    Customer: "Customer",
    Alias: "Alias",
    "Address Name": "Διεύθυνση",
    "Contact Name": "Όνομα Contact",
    Country: "Χώρα",
    "Upgrade your plan": "Αναβάθμισε την συνδρομή σου",
    "No data to display": "Δεν βρέθηκαν δεδομένα",
    "FORGOT YOUR PASSWORD": "ΞΕΧΑΣΕΣ ΤΟΝ ΚΩΔΙΚΟ ΣΟΥ ;",
    "We will send you an email to reset your password.":
      "Θα σου στείλουμε έναν κωδικό στο email σου για να κάνεις επαναφορά τον κωδικό σου",
    "Email Address": "Διεύθυνση email",
    "SEND ME THE EMAIL": "ΑΠΟΣΤΟΛΗ EMAIL",
    "Back to login page": "Πίσω στην σελίδα εισόδου",
    "Instructions to reset your password have been sent to ":
      "Οι οδηγίες για να κάνετε επαναφορά τον κωδικό σας έχουν σταλεί στο",
    " email.": " email.",
    "PASSWORD RESET": "ΕΠΑΝΑΦΟΡΑ ΚΩΔΙΚΟΥ",
    "User with email ": "Ο χρήστης με email ",
    "not found.": " δεν βρέθηκε.",
    "Please enter your new password.":
      "Παρακαλώ εισάγετε τον καινούριο κωδικό πρόσβασης",
    "Please type password based on requirements":
      "Παρακαλώ εισάγετε κωδικό βάση των παραπάνω απαιτήσεων",
    "Please retype your password.": "Παρακαλώ εισάγετε πάλι τον κωδικό σας",
    "Your passwords do not match.": "Οι κωδικοί δεν είναι ίδιοι",
    "You asked to change your password": "Ζητήσατε να αλλάξετε τον κωδικό σας",
    "type the new password": "πληκτρολογήστε τον καινούριο κωδικό πρόσβασης",
    "retype the new password":
      "ξαναπληκτρολογήστε τον καινούριο κωδικό πρόσβασης",
    "Password should contain": "Ο κωδικός πρέπει να περιέχει",
    "At least 8 characters": "Τουλάχιστον 8 χαρακτήρες",
    "At least one upper case letter": "Τουλάχιστον ένα κεφαλαίο γράμμα",
    "At least one lower case letter": "Τουλάχιστον ένα μικρό γράμμα",
    "At least one digit": "Τουλάχιστον ένας αριθμός",
    "At least one special character (Ex. !@#$%)":
      "Τουλάχιστον ένας ειδικός χαρακτήρας (Π.χ. !@#$%)",
    LOGIN: "ΕΙΣΟΔΟΣ",
    "User not found.": "Ο χρήστης δεν βρέθηκε.",
    "User not authenticated":
      "Δεν υπάρχει ο χρήστης/κωδικός που πληκτρολογήσατε",
    "CHANGE PLAN": "ΑΛΛΑΓΗ ΠΛΑΝΟΥ",
    FileDownloadError:
      "Σφάλμα στην ανάκτηση του αρχείου. Επικοινωνήστε με την υποστήριξη.",
    UpdateBookError: "Η αποθήκευση απέτυχε με σφάλμα: ",
    "An error has occurred": "Παρουσιάστηκε σφάλμα",
    Refresh: "Ανανέωση",
  },
};
